import { lazy, Suspense } from 'react'
import { Navigate, useRoutes } from 'react-router'

import ChatLayout from '@/layouts/ChatLayout'
import MainLayout from '@/layouts/MainLayout'
import ChatBotDiscover from '@/pages/chat/bot/discover'
import ChatCourse from '@/pages/chat/course'
import ChatForum from '@/pages/chat/forum'
import ChatSkills from '@/pages/chat/skills'
import EditorPage from '@/pages/Editor'

const About = lazy(() => import('@/pages/About'))
const Home = lazy(() => import('@/pages/Home'))
const NotFound = lazy(() => import('@/pages/NotFound'))
const Chat = lazy(() => import('@/pages/chat/index'))

const Loading = () => (
  <div className="flex h-screen items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
  </div>
)

const AppRouter = () => {
  return useRoutes([
    {
      path: '/chat',
      element: <ChatLayout />,
      children: [
        {
          index: true,
          element: <Chat />
        },
        {
          path: ':sessionId',
          element: <Chat />
        },
        {
          path: 'skills',
          element: <ChatSkills />
        },
        {
          path: 'bot/discover',
          element: <ChatBotDiscover />
        },
        {
          path: 'course',
          element: <ChatCourse />
        },
        {
          path: 'forum',
          element: <ChatForum />
        },
        {
          path: 'editor',
          element: <EditorPage />
        }
      ]
    },
    {
      path: '/',
      element: <Navigate to="/chat" replace />
    },
    // {
    //   path: '/',
    //   element: <MainLayout />,
    //   children: [
    //     {
    //       index: true,
    //       element: (
    //         <Suspense fallback={<Loading />}>
    //           <Home />
    //         </Suspense>
    //       )
    //     },
    //     {
    //       path: 'about',
    //       element: (
    //         <Suspense fallback={<Loading />}>
    //           <About />
    //         </Suspense>
    //       )
    //     }
    //   ]
    // },
    {
      path: '*',
      element: <Navigate to="/chat" replace />
    }
  ])
}

export default AppRouter
